export const CHAT_MESSAGES_GROUP_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  weekday: 'short',
};
